// Global API Configuration using Environment System
import { config, getWebApiUrl, getMobileApiUrl } from './environment.js'

export const API_CONFIG = {
  // Web API Configuration
  WEB_API: {
    BASE_URL: getWebApiUrl(),
    TIMEOUT: config.api.timeout,
    HEADERS: config.api.headers
  },
  
  // Mobile API Configuration
  MOBILE_API: {
    BASE_URL: getMobileApiUrl(),
    TIMEOUT: config.api.timeout,
    HEADERS: config.api.headers
  },
  
  // Storage Configuration
  STORAGE: {
    // Use Mobile API for storage operations
    BASE_URL: getMobileApiUrl(),
    ENDPOINTS: {
      CONFIG: '/storage/config',
      STATUS: '/storage/status',
      METHODS: '/storage/methods',
      UPLOAD: '/Documents/uploadDocument',
      DOWNLOAD: '/Documents/getDocument',
      DELETE: '/Documents/deleteDocument'
    }
  },
  
  // Translation Configuration
  TRANSLATION: {
    // Use Mobile API for translations
    BASE_URL: getMobileApiUrl(),
    ENDPOINTS: {
      BY_PLATFORM: '/Translation/listTranslationByPlatform',
      BY_KEY: '/Translation/listTranslationByKey',
      BY_RESOURCE: '/Translation/listTranslationByResourceKey',
      WITHOUT_MENU: '/Translation/listTranslationByPlatformWithoutMenu',
      ADD: '/Translation/addTranslation',
      UPDATE: '/Translation/updateTranslation'
    }
  }
}

// Export current configuration (for backward compatibility)
export const currentConfig = API_CONFIG

// Helper functions (for backward compatibility)
export const getApiConfig = () => API_CONFIG
export const getStorageApiUrl = () => API_CONFIG.STORAGE.BASE_URL
export const getTranslationApiUrl = () => API_CONFIG.TRANSLATION.BASE_URL

// API Base URL helper for OT service
export const getApiBaseUrl = () => {
  // Use Web API for OT operations
  return getWebApiUrl()
} 